module.exports = __webpack_public_path__ + "img/7.fe0f40de.png";